import { useNavigate } from "react-router-dom";
import useFirebaseConfig from "./useFirebaseConfig";
import { createUserWithEmailAndPassword, RecaptchaVerifier, signInAnonymously, signInWithEmailAndPassword, signInWithPhoneNumber, signOut} from "firebase/auth";

const useFirebaseAuth = () => {
    const navigate = useNavigate();
    const {auth} = useFirebaseConfig();

    const anonymousLogin = async() => {
      const result = await signInAnonymously(auth)
      .then(() => {
        return true
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        return false;
        // ...
      });
      return result;
    }

    async function generateRecaptcha(button_id){
      if (!window.recaptchaVerifier) {
        return (window.recaptchaVerifier = new RecaptchaVerifier(auth, button_id, {
            'size': 'invisible',
            'callback': (response) => {
                // reCAPTCHA solved, allow phone auth
                console.log('reCAPTCHA solved', response);
            }
        }));
    }
    }
    async function authGetPhoneCode(phone_num, button_id) {
      let appVerifier;
      auth.useDeviceLanguage();
      // reCAPTCHA 생성
      try {
          appVerifier = await generateRecaptcha(button_id);
          
      } catch (e) {
          console.error('reCAPTCHA 생성 오류:', e);
          return; // 오류 발생 시 함수 종료
      }
  
  
      try {
          const confirmationResult = await signInWithPhoneNumber(auth, `+82 ${phone_num.slice(1, phone_num.length)}`, appVerifier);
          window.confirmationResult = confirmationResult;
          console.log('SMS 전송 성공');
      } catch (error) {
          console.error('전화번호 인증 오류:', error);
          
          // 인증 실패 시 reCAPTCHA 다시 생성
          try {
              await generateRecaptcha(button_id);
              appVerifier = window.recaptchaVerifier; // 새로운 appVerifier 설정
          } catch (recaptchaError) {
              console.error('reCAPTCHA 재생성 오류:', recaptchaError);
          }
      }
  }

    async function authSendPhoneCode(phonecode){
      const code = phonecode;
      const result = await window.confirmationResult.confirm(code).then((result) => {
        return result.user;
      // ...
    }).catch((error) => {
      // User couldn't sign in (bad verification code?)
      return null;
      // ...
    });
      return result;
    }
    

    const createAccount = async(email, password) => {
      const result = await createUserWithEmailAndPassword(auth, email, password).then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        return user;
        // ...
      })
      .catch((err) => {
        console.log(err);
        return null;
        // ..
      });
      return result;
  }

    const login = async (email, password) => {
        const result = await signInWithEmailAndPassword(auth, email, password).then((userCredential) => {
          const user = userCredential.user;
          return user;
        })
        .catch((error) => {
          return error;
        });
        return result;
      }

    const logout = async () => {
        const result =  await signOut(auth).then(() => {
          return true
        }).catch((error) => {
          return error;
        });
        return result;
      }

    return {createAccount, login, logout, anonymousLogin, authGetPhoneCode, authSendPhoneCode,}
}

export default useFirebaseAuth;